import React, { useState } from "react";
import { Form } from "semantic-ui-react";
import { useFormik } from "formik";
import { User } from "../../../../api";
import { inititalValues, validationSchema } from "./RecoverForm.form";
import { toast, ToastContainer } from "react-toastify";
import { useLanguage } from "../../../../contexts";
import "./RecoverForm.scss";

const userController = new User();

export function RecoverForm() {
  const [error, setError] = useState("");
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const formik = useFormik({
    initialValues: inititalValues(),
    validationSchema: validationSchema(t),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        const response = await userController.sendEmail(formValue);
        //console.log(response)
        if(response && response.code === 200){
            toast.success(t("email_sent_check_inbox"));
        } else {
          toast.error(t("could_not_send_email") + " " + response.message);
        }

      } catch (error) {
        console.error(error);
        setError(error.msg);
      }
    },
  });


  return (
    <div className="recover-modal-form">
      <h3 className="recover-modal-form__title">{t("recover_password")}</h3>
      <p className="recover-modal-form__subtitle">{t("enter_email_to_reset_password")}</p>

      <Form onSubmit={formik.handleSubmit} className="recover-form">
        <Form.Field error={!!formik.errors.email}>
          <label>{t("email")}</label>
          <div className="password-input-wrapper">
            <input
              name="email"
              type="email"
              placeholder={t("email")}
              onChange={formik.handleChange}
              value={formik.values.email}
            />
          </div>
          {formik.errors.email && (
            <div className="ui pointing above prompt label">
              {formik.errors.email}
            </div>
          )}
        </Form.Field>

        <Form.Button type="submit" primary fluid size="large" loading={formik.isSubmitting}>
          {t("send")}
        </Form.Button>

        {error && <p className="recover-error">{error}</p>}
      </Form>

      <ToastContainer
        position="top-center"
        autoClose={3200}
        hideProgressBar
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
}
